import App from '@/models/App'

export default class TrafficShipSchedule extends App {
    static get entity() {
        return 'TrafficShipSchedules'
    }

    static all() {
        return this.query().orderBy('createdAt', 'desc').get()
    }

    static findById(id) {
        return this.query().whereId(id).withAllRecursive().first()
    }

    static fields() {
        return {
            id: this.attr(''),
            trafficShipId: this.attr(''),
            trafficShipFormFormatId: this.attr(''),
            voyageNumber: this.attr(''),
            name: this.attr(''),
            title: this.attr(''),
            depPort: this.attr(''),
            destPort: this.attr(''),
            from: this.attr(''),
            to: this.attr(''),
            comment: this.attr(''),
            background: this.attr(''),
            account: this.attr({}),
            trafficShip: this.attr({}),
            events: this.attr([]),
            cargos: this.attr([]),
            formValues: this.attr([]),
            sharedUsers: this.attr([]),
            departurePort: this.attr({}),
            destinationPort: this.attr({}),
        }
    }

    static apiConfig = {
        actions: {
            fetch(params) {
                return this.get(`traffic/ship/schedules`, {
                    params: App.get(params),
                    headers: {
                        Authorization: 'Bearer ' + App.apiToken(),
                        'Accept-Language': App.acceptLanguage(),
                    },
                    dataKey: 'data',
                    baseURL: App.apiURL(),
                })
            },
            fetchCurrent(params) {
                return this.get(`traffic/ship/schedules/current`, {
                    params: App.get(params),
                    headers: {
                        Authorization: 'Bearer ' + App.apiToken(),
                        'Accept-Language': App.acceptLanguage(),
                    },
                    dataKey: 'data',
                    baseURL: App.apiURL(),
                })
            },
            paginatePast(params) {
                return this.get(`traffic/ship/schedules/paginatePast`, {
                    params: App.get(params),
                    headers: {
                        Authorization: 'Bearer ' + App.apiToken(),
                        'Accept-Language': App.acceptLanguage(),
                    },
                    dataKey: 'data',
                    baseURL: App.apiURL(),
                })
            },
            find(trafficShipScheduleId) {
                return this.get(
                    `traffic/ship/schedules/${trafficShipScheduleId}`,
                    {
                        headers: {
                            Authorization: 'Bearer ' + App.apiToken(),
                            'Accept-Language': App.acceptLanguage(),
                        },
                        dataKey: 'data',
                        baseURL: App.apiURL(),
                    }
                )
            },
            create(params) {
                return this.post(`/traffic/ship/schedules`, App.post(params), {
                    params: {},
                    headers: {
                        Authorization: 'Bearer ' + App.apiToken(),
                        'Accept-Language': App.acceptLanguage(),
                    },
                    baseURL: App.apiURL(),
                })
            },
            update(trafficShipScheduleId, params) {
                return this.patch(
                    `traffic/ship/schedules/${trafficShipScheduleId}`,
                    App.patch(params),
                    {
                        params: {},
                        headers: {
                            Authorization: 'Bearer ' + App.apiToken(),
                            'Accept-Language': App.acceptLanguage(),
                        },
                        baseURL: App.apiURL(),
                    }
                )
            },
            destroy(trafficShipScheduleId) {
                return this.delete(
                    `traffic/ship/schedules/${trafficShipScheduleId}`,
                    {
                        params: {},
                        headers: {
                            Authorization: 'Bearer ' + App.apiToken(),
                            'Accept-Language': App.acceptLanguage(),
                        },
                        delete: trafficShipScheduleId,
                        baseURL: App.apiURL(),
                    }
                )
            },
            share(trafficShipScheduleId, params) {
                return this.post(
                    `traffic/ship/schedules/${trafficShipScheduleId}/share`,
                    App.post(params),
                    {
                        params: {},
                        headers: {
                            Authorization: 'Bearer ' + App.apiToken(),
                            'Accept-Language': App.acceptLanguage(),
                        },
                        baseURL: App.apiURL(),
                    }
                )
            },
            unshare(trafficShipScheduleId, params) {
                return this.delete(
                    `traffic/ship/schedules/${trafficShipScheduleId}/share`,
                    {
                        params: params,
                        headers: {
                            Authorization: 'Bearer ' + App.apiToken(),
                            'Accept-Language': App.acceptLanguage(),
                        },
                        baseURL: App.apiURL(),
                    }
                )
            },
            sharePrivilegeUpdate(params) {
                return this.patch(
                    `traffic/ship/schedules/privileges`,
                    App.patch(params),
                    {
                        params,
                        headers: {
                            Authorization: 'Bearer ' + App.apiToken(),
                            'Accept-Language': App.acceptLanguage(),
                        },
                        dataKey: 'data',
                        baseURL: App.apiURL(),
                    }
                )
            },
            shareSchedulePrivilegeUpdate(id, params) {
                return this.patch(
                    `traffic/ship/schedules/privileges/${id}`,
                    App.patch(params),
                    {
                        params,
                        headers: {
                            Authorization: 'Bearer ' + App.apiToken(),
                            'Accept-Language': App.acceptLanguage(),
                        },
                        dataKey: 'data',
                        baseURL: App.apiURL(),
                    }
                )
            },
        },
    }
}
